import { useMemo } from "react";
import { useShallow } from "zustand/shallow";

import { useGenomeViewerStore } from "../../../store/store.ts";
import { getGroupHeight } from "../utils/get-group-height.ts";

export function useGroupHeight(): number {
  const size = useGenomeViewerStore(
    useShallow((state) => [...state.trackGroups.values()].filter((group) => group.graphics.isVisible).length),
  );

  const groupHeight = useMemo(() => getGroupHeight(size), [size]);

  return groupHeight;
}
